/**
 * Compatibility shim: the app used to ask for full name / email / default
 * geography in a first-run dialog. We now stamp gap and review authors from
 * the server session instead, so the legacy `useProfile` hook just adapts a
 * `CurrentUser` into the old shape and reports the dialog as already
 * complete. Geography is no longer per-user — the topbar selector owns it.
 */

import { useContext } from 'react';

import type { Profile } from '../types';
import { GEO_ALL } from '../types';
import { SessionContext } from './session';

export const DEFAULT_PROFILE: Profile = {
  full_name: '',
  email: '',
  geography: GEO_ALL,
};

export function useProfile(): {
  profile: Profile | null;
  isComplete: boolean;
} {
  const user = useContext(SessionContext);
  if (!user) {
    return { profile: null, isComplete: false };
  }
  return {
    profile: {
      full_name: user.full_name,
      email: user.email,
      geography: GEO_ALL,
    },
    isComplete: true,
  };
}
